"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = exports.SliderRightValue = exports.SliderLeftValue = exports.SliderRange = exports.SliderTrack = exports.Slider = exports.LimitWrapper = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.Container = styled_components_1.default.div `
  width: 100%;
  position: relative;
  display: flex;
`;
exports.LimitWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  height: 51px;
`;
exports.Slider = styled_components_1.default.div `
  position: relative;
  width: 100%;
`;
exports.SliderTrack = styled_components_1.default.div `
  position: absolute;
  border-radius: 3px;
  height: 7px;
  background-color: ${colors_1.PALE_GREEN};
  width: 100%;
  z-index: 1;
`;
exports.SliderRange = styled_components_1.default.div `
  position: absolute;
  border-radius: 3px;
  height: 7px;
  background-color: ${colors_1.DARK_GREEN};
  z-index: 2;
`;
exports.SliderLeftValue = styled_components_1.default.div `
  margin: 20px 8px;
  font-family: SwegonBrown;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  color: ${colors_1.BLACK};
  white-space: nowrap;
`;
exports.SliderRightValue = styled_components_1.default.div `
  margin: 20px 8px;
  font-family: SwegonBrown;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  text-align: right;
  color: ${colors_1.BLACK};
  white-space: nowrap;
  margin-left: -40px;
`;
exports.Input = styled_components_1.default.input `
  appearance: none;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: transparent;
  pointer-events: none;
  position: absolute;
  height: 0;
  width: 100%;
  outline: none;
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    -webkit-tap-highlight-color: transparent;
    background-color: ${colors_1.DARK_GREEN};
    border: none;
    border-radius: 50%;
    box-shadow: 0 0 1px 1px ${colors_1.DARK_GREEN};
    cursor: pointer;
    height: 18px;
    width: 18px;
    margin-top: 4px;
    pointer-events: all;
    position: relative;
  }
  &::-moz-range-thumb {
    background-color: ${colors_1.DARK_GREEN};
    border: none;
    border-radius: 50%;
    box-shadow: 0 0 1px 1px ${colors_1.DARK_GREEN};
    cursor: pointer;
    height: 18px;
    width: 18px;
    margin-top: 4px;
    pointer-events: all;
    position: relative;
  }
  z-index: ${({ $zIndex }) => $zIndex || 4};
`;
//# sourceMappingURL=RangeSlider.styles.js.map